/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ReportGenerationOptions {
    getFixupPrototypeFunction() { return ReportGenerationOptions.fixupPrototype; }

    static newInstance(model: Partial<ReportGenerationOptions>): ReportGenerationOptions {
        let obj = Object.assign(new ReportGenerationOptions(), model);
        ReportGenerationOptions.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ReportGenerationOptions>): ReportGenerationOptions {
        if (!model) return null;
        return ReportGenerationOptions.newInstance(<ReportGenerationOptions> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ReportGenerationOptions) {
        if (!obj) return;

        models.ReportGenerationOptions.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ReportGenerationOptions): boolean {
        Object.setPrototypeOf(obj, ReportGenerationOptions.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.timeout === undefined) {
            this.timeout = 0;
        }
    }

    /**
     * Orientation of the report structure
     */
    orientation: models.ReportOrientation;

    /**
     * Page-size of the report structure
     */
    page_size: models.ReportPageSize;

    /**
     * header-html content of the report
     */
    header_html: string;

    /**
     * footer-html content of the report
     */
    footer_html: string;

    /**
     * Left aligned footer text
     */
    footer_left: string;

    /**
     * footer font size
     */
    footer_font_size: string;

    /**
     * footer font name
     */
    footer_font_name: string;

    /**
     * Page top margin size
     */
    margin_top: string;

    /**
     * Page right margin size
     */
    margin_right: string;

    /**
     * Page bottom margin size
     */
    margin_bottom: string;

    /**
     * Page left margin size
     */
    margin_left: string;

    /**
     * Max time in seconds to wait for report to generate.
     */
    timeout: number;

}
